<template>
  <v-container fluid>
      <div class='font-weight-bold'>Cash/Personal Check Terms</div>
      <v-row>
        <v-col cols="12">
          <p>I will pay by check:</p>
          <ol type="A">
            <li>Monthly in 10 (September - June) to align with monthly automated dues deductions by MEA;</li>
            <li>Semi-annually (at least one-half of the dues amount paid by October 31 and the remainder by the last day of February);</li>
            <li>In one lump sum by October 31.</li>
          </ol>
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
  //import axios from 'axios'
  export default {
    name: 'IblCashCheck',
    data:() => ({    
        
    }),
    methods:{        
    },
    mounted:function(){

    },
    watch:{        
    }
  }
</script>

<style scoped>
ol {
  counter-reset: list;
}
ol > li {
  list-style: none;
}
ol > li:before {
  content: counter(list, upper-alpha) ") ";
  counter-increment: list;
}
</style>